(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-search"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('searchPage', () => ({
      isLoading: false,
      searchQuery: '',
      searchResult: false,
      nextPageCount: 1,
      hasNextPage: false,
      init() {
        const params = new URLSearchParams(window.location.search);
        const page = params.get('page');

        this.getHasNextPage(document, page || this.nextPageCount);

        window.onpopstate = () => {
          window.location.reload();
        };
      },
      addNextPageItems(items) {
        const collectionItemsGrid = document.getElementById('coll-grid');
        items.forEach((item) => {
          collectionItemsGrid.append(item);
        });
      },
      getHasNextPage(node, counter = 1) {
        this.nextPageCount = counter;
        this.hasNextPage = !!node.querySelector('[data-next-page]');
      },
      getNewItems(response) {
        return response.querySelectorAll('#coll-grid article');
      },
      scrollToAnchor(node) {
        const anchorBlock = node;

        if (anchorBlock) {
          const elementPosition = anchorBlock.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition +
            window.pageYOffset -
            parseFloat(document.documentElement.style.getPropertyValue('--header-height') || 0);

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      },
      changeUrl(url) {
        window.history.pushState({}, url, url);
      },
      async renderSearch() {
        this.isLoading = true;
        this.resultsCount = 0;

        const url = `/search?q=${this.searchQuery}&type=product`;
        this.changeUrl(url);

        try {
          if (!this.searchQuery.length) {
            this.searchResult = false;
            this.isLoading = false;
            return;
          }

          const currentLayout = document.getElementById(`main-search`);

          const response = await this.get(url, { responseType: 'document' });
          const newLayout = response.getElementById(`main-search`);

          if (newLayout) {
            currentLayout.outerHTML = newLayout.outerHTML;
          }

          this.searchResult = true;
          this.isLoading = false;
        } catch (e) {
          this.isLoading = false;
          console.log(e);
        }
      },
      async get(url, config = {}) {
        try {
          const options = Object.assign(
            {
              method: 'GET',
              headers: config.headers || {},
            },
            config,
          );

          const response = await fetch(url, options);

          if (!response.ok) {
            throw new Error(`Fetch error: ${response.status} ${response.statusText}`);
          }

          const text = await response.text();
          return new DOMParser().parseFromString(text, 'text/html');
        } catch (e) {
          console.log(e);
        }
      },
      async loadMore(newURL) {
        this.isLoading = true;

        try {
          const response = await this.get(newURL, { responseType: 'document' });

          const newItems = this.getNewItems(response);
          if (newItems && newItems.length) {
            this.addNextPageItems(newItems);
            this.isLoading = false;
          }

          this.getHasNextPage(response, this.nextPageCount);

          this.isLoading = false;
        } catch (e) {
          console.log(e);
          this.isLoading = false;
        }
      },
      async loadMoreProducts() {
        this.nextPageCount++;

        const newURL =
          window.location.href.split('?').shift() +
          '?q=' +
          this.searchQuery +
          '&type=product&page=' +
          this.nextPageCount;
        await this.loadMore(newURL);
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var LOOX_MODAL_SELECTORS = [
      '#looxReviews',
      '#looxReviewsModal',
      '#looxOverlay_looxModalFrame',
      '[id^="looxOverlay_"]',
      '#looxModalFrame',
      '.loox-lightbox',
      '.lxs-lightbox',
      '.loox-modal',
      '.loox-reviews-modal',
      '.loox-overlay',
      '.lxs-overlay',
      '[class*="loox"][class*="lightbox"]',
      '[class*="loox"][class*="modal"]',
      '[class*="loox"][class*="overlay"]',
      '[class*="lxs"][class*="modal"]',
      '[class*="lxs"][class*="overlay"]',
    ];
    var LOOX_TRIGGER_SELECTOR = '.bundle-reviews-loox-trigger, [id^="BundleLooxTrigger-"]';
    var LOOX_CLOSE_CONSECUTIVE = 3;
    var LOOX_WATCH_MAX_TICKS = 600;

    var looxWatchInterval = null;
    var looxMutationObserver = null;
    var looxEscapeHandler = null;
    var looxClickHandler = null;
    var looxModalActive = false;
    var looxActiveSectionId = null;
    var looxClosedStreak = 0;
    var looxWatchTicks = 0;

    function isInsideBundleLooxTrigger(node) {
      if (!node || typeof node.closest !== 'function') {
        return false;
      }

      return !!node.closest(LOOX_TRIGGER_SELECTOR);
    }

    function isVisibleLooxModalNode(node) {
      if (!node || isInsideBundleLooxTrigger(node)) {
        return false;
      }

      var style = window.getComputedStyle(node);

      if (style.display === 'none' || style.visibility === 'hidden') {
        return false;
      }

      if (parseFloat(style.opacity) <= 0) {
        return false;
      }

      var rect = node.getBoundingClientRect();

      return rect.width > 80 && rect.height > 80;
    }

    function setBundleHeaderHidden(hidden) {
      var root = document.documentElement;
      var sentinelId = 'bundle-loox-hide-header';
      var sentinel = document.getElementById(sentinelId);
      var siteHeader = document.querySelector('header');

      if (hidden) {
        root.classList.add('bundle-loox-modal-open');

        if (siteHeader) {
          siteHeader.style.transform = 'translateY(-100%)';
        }

        if (!sentinel) {
          sentinel = document.createElement('div');
          sentinel.id = sentinelId;
          sentinel.setAttribute('data-hide-header', '');
          sentinel.setAttribute('aria-hidden', 'true');
          sentinel.style.cssText =
            'position:fixed;top:0;left:0;width:100%;height:var(--header-height,120px);pointer-events:none;z-index:1;';
          document.body.appendChild(sentinel);
        }
      } else {
        root.classList.remove('bundle-loox-modal-open');

        if (siteHeader) {
          siteHeader.style.transform = '';
        }

        if (sentinel) {
          sentinel.remove();
        }
      }

      window.dispatchEvent(new Event('scroll'));
    }

    function getLooxClickTarget(sectionId) {
      var root = document.getElementById('BundleLooxTrigger-' + sectionId);

      if (!root) {
        return null;
      }

      var target = root.querySelector('.loox-trust-badge-widget-content-container');

      if (!target) {
        target = root.querySelector('.loox-trust-badge-container');
      }

      if (!target) {
        target = root.querySelector('[data-loox-open-reviews]');
      }

      return target;
    }

    function isLooxModalOpen() {
      if (
        document.body.classList.contains('loox-modal-open') ||
        document.documentElement.classList.contains('loox-modal-open')
      ) {
        return true;
      }

      for (var i = 0; i < LOOX_MODAL_SELECTORS.length; i++) {
        var nodes = document.querySelectorAll(LOOX_MODAL_SELECTORS[i]);

        for (var j = 0; j < nodes.length; j++) {
          if (isVisibleLooxModalNode(nodes[j])) {
            return true;
          }
        }
      }

      return false;
    }

    function stopLooxCloseWatch() {
      if (looxWatchInterval) {
        clearInterval(looxWatchInterval);
        looxWatchInterval = null;
      }

      if (looxMutationObserver) {
        looxMutationObserver.disconnect();
        looxMutationObserver = null;
      }

      if (looxEscapeHandler) {
        document.removeEventListener('keydown', looxEscapeHandler);
        looxEscapeHandler = null;
      }

      if (looxClickHandler) {
        document.removeEventListener('click', looxClickHandler, true);
        looxClickHandler = null;
      }

      looxWatchTicks = 0;
      looxClosedStreak = 0;
    }

    function closeLooxSession() {
      if (!looxModalActive && !document.documentElement.classList.contains('bundle-loox-modal-open')) {
        stopLooxCloseWatch();
        looxActiveSectionId = null;
        return;
      }

      looxModalActive = false;
      setBundleHeaderHidden(false);
      stopLooxCloseWatch();
      looxActiveSectionId = null;
    }

    function openLooxSession(sectionId) {
      looxModalActive = true;
      looxActiveSectionId = sectionId;
      looxClosedStreak = 0;
      looxWatchTicks = 0;
      setBundleHeaderHidden(true);
    }

    function handleLooxModalState() {
      looxWatchTicks = looxWatchTicks + 1;

      if (isLooxModalOpen()) {
        looxClosedStreak = 0;

        if (!looxModalActive) {
          openLooxSession(looxActiveSectionId);
        }

        return;
      }

      if (!looxModalActive) {
        return;
      }

      looxClosedStreak = looxClosedStreak + 1;

      if (looxClosedStreak >= LOOX_CLOSE_CONSECUTIVE) {
        closeLooxSession();
        return;
      }

      if (looxWatchTicks >= LOOX_WATCH_MAX_TICKS) {
        closeLooxSession();
      }
    }

    function scheduleLooxStateCheck(delayMs) {
      setTimeout(handleLooxModalState, delayMs || 0);
    }

    function scheduleLooxCloseAfterUserAction(delayMs) {
      setTimeout(function () {
        if (!isLooxModalOpen()) {
          closeLooxSession();
          return;
        }

        scheduleLooxStateCheck(0);
      }, delayMs || 200);
    }

    function isLooxOverlayElement(node) {
      if (!node || node.nodeType !== 1) {
        return false;
      }

      if (node.id && node.id.indexOf('looxOverlay_') === 0) {
        return true;
      }

      if (node.classList && node.classList.contains('loox-overlay')) {
        return true;
      }

      return false;
    }

    function bindLooxOverlayElement(overlay) {
      if (!overlay || overlay.dataset.bundleLooxBound === 'true') {
        return;
      }

      overlay.dataset.bundleLooxBound = 'true';

      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) {
          scheduleLooxCloseAfterUserAction(400);
        }
      });
    }

    function bindAllLooxOverlays() {
      var overlays = document.querySelectorAll('[id^="looxOverlay_"], .loox-overlay[aria-modal="true"]');

      for (var i = 0; i < overlays.length; i++) {
        bindLooxOverlayElement(overlays[i]);
      }
    }

    function onLooxDomMutation(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];

        if (mutation.type === 'childList') {
          if (mutation.addedNodes) {
            for (var a = 0; a < mutation.addedNodes.length; a++) {
              var added = mutation.addedNodes[a];

              if (isLooxOverlayElement(added)) {
                bindLooxOverlayElement(added);
              }

              if (added && added.querySelectorAll) {
                var nestedOverlays = added.querySelectorAll('[id^="looxOverlay_"], .loox-overlay[aria-modal="true"]');

                for (var n = 0; n < nestedOverlays.length; n++) {
                  bindLooxOverlayElement(nestedOverlays[n]);
                }
              }
            }
          }

          if (mutation.removedNodes && looxModalActive) {
            for (var r = 0; r < mutation.removedNodes.length; r++) {
              if (isLooxOverlayElement(mutation.removedNodes[r])) {
                closeLooxSession();
                return;
              }
            }
          }
        }

        if (mutation.type === 'attributes' && mutation.target && isLooxOverlayElement(mutation.target)) {
          var overlayStyle = window.getComputedStyle(mutation.target);

          if (
            overlayStyle.display === 'none' ||
            overlayStyle.visibility === 'hidden' ||
            parseFloat(overlayStyle.opacity) <= 0
          ) {
            scheduleLooxCloseAfterUserAction(450);
          }
        }
      }

      bindAllLooxOverlays();
      scheduleLooxStateCheck(0);
    }

    function startLooxCloseWatch(sectionId) {
      stopLooxCloseWatch();
      looxActiveSectionId = sectionId;
      looxClosedStreak = 0;
      looxWatchTicks = 0;

      bindAllLooxOverlays();

      looxWatchInterval = setInterval(handleLooxModalState, 100);

      looxMutationObserver = new MutationObserver(onLooxDomMutation);
      looxMutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'opacity'],
      });

      looxEscapeHandler = function (event) {
        if (event.key !== 'Escape' || !looxModalActive) {
          return;
        }

        scheduleLooxCloseAfterUserAction(400);
      };

      looxClickHandler = function (event) {
        var target = event.target;

        if (!target || typeof target.closest !== 'function') {
          return;
        }

        if (
          target.closest(
            '#close-button, .hcp-modal-header-close-button, .loox-close, .lxs-close, [data-loox-close], [class*="loox"][class*="close"], [class*="lxs"][class*="close"], [aria-label="Close"], [aria-label*="close" i]'
          )
        ) {
          scheduleLooxCloseAfterUserAction(400);
          return;
        }

        if (target.closest('[id^="looxOverlay_"], .loox-overlay[aria-modal="true"]')) {
          var overlay = target.closest('[id^="looxOverlay_"], .loox-overlay[aria-modal="true"]');

          if (overlay && target === overlay) {
            scheduleLooxCloseAfterUserAction(400);
          }
        }
      };

      document.addEventListener('keydown', looxEscapeHandler);
      document.addEventListener('click', looxClickHandler, true);
    }

    function triggerLooxOpen(sectionId) {
      var target = getLooxClickTarget(sectionId);

      if (target && typeof target.click === 'function') {
        target.click();
        return true;
      }

      if (window.loox && typeof window.loox.openReviews === 'function') {
        window.loox.openReviews();
        return true;
      }

      if (window.Loox && typeof window.Loox.openReviewModal === 'function') {
        window.Loox.openReviewModal();
        return true;
      }

      var pageTrigger = document.querySelector(
        '.loox-trust-badge-widget-content-container, .loox-trust-badge-container[data-loox-open-reviews], [data-loox-open-reviews=true]'
      );

      if (pageTrigger && typeof pageTrigger.click === 'function') {
        pageTrigger.click();
        return true;
      }

      return false;
    }

    function waitForLooxModal(sectionId) {
      var ticks = 0;

      var timer = setInterval(function () {
        ticks = ticks + 1;

        if (isLooxModalOpen()) {
          clearInterval(timer);
          openLooxSession(sectionId);
          startLooxCloseWatch(sectionId);
          return;
        }

        if (ticks > 60) {
          clearInterval(timer);
          closeLooxSession();
        }
      }, 100);
    }

    function preloadLooxForSection(sectionId) {
      if (!window.bundleLooxPreloaded) {
        window.bundleLooxPreloaded = {};
      }

      if (window.bundleLooxPreloaded[sectionId]) {
        return;
      }

      var ticks = 0;

      var timer = setInterval(function () {
        ticks = ticks + 1;
        var target = getLooxClickTarget(sectionId);

        if (target || window.loox || window.Loox || ticks > 40) {
          clearInterval(timer);
          window.bundleLooxPreloaded[sectionId] = !!target;
        }
      }, 250);
    }

    function preloadAllBundleLooxTriggers() {
      var triggers = document.querySelectorAll('[id^="BundleLooxTrigger-"]');

      for (var i = 0; i < triggers.length; i++) {
        var sectionId = triggers[i].id.replace('BundleLooxTrigger-', '');
        preloadLooxForSection(sectionId);
      }
    }

    function openLooxPopup(sectionId) {
      var attempts = 0;

      if (looxModalActive) {
        closeLooxSession();
      }

      looxActiveSectionId = sectionId;

      function tryOpen() {
        attempts = attempts + 1;

        if (triggerLooxOpen(sectionId)) {
          waitForLooxModal(sectionId);
          return;
        }

        if (attempts < 15) {
          setTimeout(tryOpen, 200);
          return;
        }

        closeLooxSession();
      }

      tryOpen();
    }

    window.openBundleLooxReviews = openLooxPopup;
    window.bundleLooxPreloaded = window.bundleLooxPreloaded || {};

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', preloadAllBundleLooxTriggers);
    } else {
      preloadAllBundleLooxTriggers();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
